import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getLatestMessage } from "redux-flash";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";

import CenteredForm from "../utils/form/CenteredForm";
import { required } from "../utils/form/formValidation";

import { passwordResetRequest } from "./actions";

import styles from "./PasswordReset.scss";

class PasswordReset extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    passwordResetRequest: PropTypes.func.isRequired,
    "password-reset": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
    }).isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  submit = (values) => {
    const accessToken = this.props.location.search;

    this.props.passwordResetRequest({ ...values, accessToken });
  };
  render() {
    const {
      handleSubmit,
      "password-reset": { requesting, successful },
      snackbarMessage,
    } = this.props;

    return (
      <div className={styles.container}>
        <a href="/patient-playlists">
          <img
            src="assets/img/DD-logo-long-noir.png"
            className={styles.title_DD}
          />
        </a>
        <CenteredForm
          title="Réinitialiser votre mot de passe"
          handleOnSubmit={handleSubmit(this.submit)}
          snackbarMessage={snackbarMessage}
        >
          <div className="mb2">
            <Field
              name="password"
              type="password"
              label="Nouveau mot de passe"
              component={TextField}
              validate={[required]}
              fullWidth
            />
          </div>
          <div className="mb3">
            <Field
              name="passwordCheck"
              type="password"
              label="Confirmation"
              component={TextField}
              validate={[required]}
              fullWidth
            />
          </div>
          {!successful && (
            <Button
              type={requesting ? "" : "submit"}
              variant="raised"
              color="secondary"
              fullWidth
            >
              {!requesting && !successful && "Réinitialiser"}
              {requesting && <CircularProgress className={styles.requesting} />}
            </Button>
          )}
          {successful && (
            <Link to="/login" replace>
              <Button variant="raised" color="secondary" fullWidth>
                Continuer
              </Button>
            </Link>
          )}
        </CenteredForm>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  "password-reset": state["password-reset"],
  snackbarMessage: getLatestMessage(state) || {},
});

const ConnectedPasswordReset = connect(mapStateToProps, {
  passwordResetRequest,
})(PasswordReset);

export default reduxForm({
  form: "password-reset",
})(ConnectedPasswordReset);



// WEBPACK FOOTER //
// ./src/pages/password-reset/PasswordReset.jsx